module.exports = __webpack_public_path__ + "img/landing-2-en-US.57db0f6.png";